// for modifying CSS injection order. make material-ui's styles weaker.
// jss-preset-default and react-jss have no style declaration.
// see:
//   https://material-ui.com/customization/css-in-js/#css-injection-order
//   https://stackoverflow.com/questions/48791796/material-ui-overrides-react-emotion-rules

const { create } = require('jss');
const createGenerateClassName = require('@material-ui/core/styles/createGenerateClassName').default;
const jssPreset = require('@material-ui/core/styles/jssPreset').default;
const { createElement } = require('react');
const { JssProvider } = require('react-jss');

const styleNode = document.createElement('style');
styleNode.id = 'insertion-point-jss';
document.head.insertBefore(styleNode, document.head.firstChild);

const jss = create(jssPreset());
jss.options.createGenerateClassName = createGenerateClassName;
jss.options.insertionPoint = document.getElementById('insertion-point-jss');

module.exports = {
  JssProvider,
  jss,
};
